'use client';

import classes from "./public_provider_room.module.css";
import Check from '@/assets/svg/icons/check.svg';
import X from '@/assets/svg/icons/x.svg';
import FeaturedIcon from "../../common/icons/featured_icon";
import CustomBadge from "@/components/common/badges/badge";

export default function PublicProviderRoomsMobile({provider, preview_value}) {

    if(!preview_value && (!provider.rooms || provider.rooms.length === 0)) return <></>

    return <>
        <div className={`${classes["public-provider-rooms-mobile-container"]}`}>
            {(preview_value ? preview_value : provider.rooms).map((room, i) => 
                <div key={`mobile-rooms-top-${i}`} className={`${classes["public-provider-rooms-mobile-card"]}`}>
                    <div className={`${classes["public-provider-rooms-mobile-card-title"]}`}>
                        <p>{room.name}</p>
                    </div>
                    <div className="padding-2">
                        <h5 className={`${preview_value ? "display-sm-semibold" : "text-xl-medium"}`}>Befogadóképesség (fő)</h5>
                        <div className={`d-flex flex-row flex-wrap gap-2 margin-top-1`}>
                            <CustomBadge size="sm" color={`gray`} >Ültetett: {room.ultetett_kiszolgalas ? room.ultetett_kiszolgalas : "-"}</CustomBadge>
                            <CustomBadge size="sm" color={`gray`} >Svédasztalos: {room.svedasztalos_kiszolgalas ? room.svedasztalos_kiszolgalas : "-"}</CustomBadge>
                            <CustomBadge size="sm" color={`gray`} >Állófogadás: {room.allofogadas ? room.allofogadas : "-"}</CustomBadge>
                            
                        </div>
                    </div>
                    <div className="w-100 padding-2">
                        <h5 className={`${preview_value ? "display-sm-semibold" : "text-xl-medium"}`}>Asztal elrendezések</h5>
                        <div className={`d-flex flex-row flex-wrap gap-2 margin-top-1 align-items-center`}>
                            <div className={`${classes["public-provider-rooms-mobile-card-item"]}`}>
                                <FeaturedIcon size="sm" color={(room.tablaasztalos && +room.tablaasztalos === 1) ? "primary-strong" : "error"} icon={(room.tablaasztalos && +room.tablaasztalos === 1) ? Check : X} />
                                <p className="margin-0 color-gray-500 text-xs-medium w-auto">Táblaasztalos</p>
                            </div>
                            <div className={`${classes["public-provider-rooms-mobile-card-item"]}`}>
                                <FeaturedIcon size="sm" color={(room.korasztalos && +room.korasztalos === 1) ? "primary-strong" : "error"} icon={(room.korasztalos && +room.korasztalos === 1) ? Check : X} />
                                <p className="margin-0 color-gray-500 text-xs-medium w-auto">Körasztalos</p>
                            </div>
                            <div className={`${classes["public-provider-rooms-mobile-card-item"]}`}>
                                <FeaturedIcon size="sm" color={(room.u_alak && +room.u_alak === 1) ? "primary-strong" : "error"} icon={(room.u_alak && +room.u_alak === 1) ? Check : X} />
                                <p className="margin-0 color-gray-500 text-xs-medium w-auto">U alak</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </>
}
